import { useInfiniteQuery } from "@tanstack/react-query";
import { api } from "../../../singleton/axios";
import { NotificationsPage } from "../types";

export const NOTIFICATIONS_INBOX_QUERY_KEY = ["notifications", "inbox"] as const;

const PAGE_SIZE = 30;

/**
 * The inbox history, paged behind a Load-more button. Refetched every time
 * the inbox opens, so New always matches the badge that was just tapped.
 *
 * Deliberately NO `maxPages`: TanStack's page cap is built for two-way paging.
 * With a forward-only button, loading page six would silently drop page one
 * with no way back to it. Loaded pages are simply kept — at 30 rows a page
 * that is a non-issue.
 */
export const useNotifications = () =>
  useInfiniteQuery({
    queryKey: NOTIFICATIONS_INBOX_QUERY_KEY,
    initialPageParam: null as string | null,
    queryFn: async ({ pageParam }) => {
      const params: Record<string, string | number> = { limit: PAGE_SIZE };
      if (pageParam) params.before = pageParam;
      const { data } = await api.get<NotificationsPage>("/notifications", { params });
      return data;
    },
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    refetchOnMount: "always",
  });
